import { Component, OnInit, ViewChild, AfterViewInit, Output, EventEmitter, Input, ElementRef } from '@angular/core';
import { ChartModel } from './Chart.model';
import { ComboBoxComponent } from '../../../combo-box/combo-box.component';
import { TextBoxComponent } from '../../../text-box/text-box.component';
import { TextAreaComponent } from '../../../text-area/text-area.component';
import { CheckBoxComponent } from '../../../check-box/check-box.component';
import { HiddenComponent } from '../../../hidden/hidden.component';
// import { FileuploadComponent } from '../../../fileupload/fileupload.component';
import { DateComponent } from '../../../date/date.component';
import { ButtonComponent } from '../../../button/button.component';
import { AmountComponent } from '../../../amount/amount.component';
import { FormComponent } from '../../../form/form.component';
import { ToggleSwitchComponent } from '../../../toggle-switch/toggle-switch.component';
import { ButtongroupComponent } from '../../../buttongroup/buttongroup.component';
import { CardsgroupComponent } from '../../../cardsgroup/cardsgroup.component';
import { RangeBarComponent } from '../../../range-bar/range-bar.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { PopupModalComponent } from '../../../popup-modal/popup-modal.component';
import { ServiceStock } from '../../../service-stock.service';
import { LabelComponent } from '../../../label/label.component';
import { HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { PasswordComponent } from '../../../password/password.component';
import { RadioButtonComponent } from '../../../radio-button/radio-button.component';

const customCss: string = '';

@Component({
  selector: 'app-charts',
  templateUrl: './Chart.component.html'
})
export class ChartsComponent extends FormComponent implements OnInit, AfterViewInit {
  // @Input('searchMode') searchMode: string = "symbol";

  @Output() chartSelected: EventEmitter<any> = new EventEmitter<any>();
  // @ViewChild('cmbChart', { static: false }) cmbChart: ComboBoxComponent;
  // @Output() selectedOption: EventEmitter<any> = new EventEmitter<any>();

  dataTable: any;
  mapping: any
  skeletonContentLoaded = false;
  // chart: anychart.charts.Stock;
  chart: any = null;
  dataSource = [];
  table: any
  // table: anychart.data.Table;
  async revalidate(): Promise<number> {
    var totalErrors = 0;
    super.beforeRevalidate();
    await Promise.all([
      // this.revalidateBasicField('cmbChart'),
    ]).then((errorCounts) => {
      errorCounts.forEach((errorCount) => {
        totalErrors += errorCount;
      });
    });
    this.errors = totalErrors;
    super.afterRevalidate();
    return totalErrors;
  }
  constructor(services: ServiceStock) {
    super(services);
    // this.value = new ChartModel();
    // this.componentCode = 'Chart';
    anychart.licenseKey("intellectdesign-d34a0ad1-63e85597");
    anychart.format.locales.default.numberLocale.decimalsCount = 2;
    anychart.format.locales.default.numberLocale.zeroFillDecimals = true;
    anychart.format.locales.default.numberLocale.groupsSeparator = ',';
  }
  setReadOnly(readOnly) {
    super.setBasicFieldsReadOnly(readOnly);
  }
  async onFormLoad() {
    this.setInputs(this.services.dataStore.getData(this.services.routing.currModal));
    // this.cmbChart.setValue(this.services.dataStore.getData("chartID"));
    this.setDependencies();
  }
  setInputs(param: any) {
    let params = this.services.http.mapToJson(param);
    if (params['mode']) {
      this.mode = params['mode'];
    }
  }
  async submitForm(path, apiCode, serviceCode) {
    this.submitData['formName'] = 'Chart';
    await super.submit(path, apiCode, serviceCode);
  }
  getFieldInfo() {
    this.amountComponent.forEach(field => { this.additionalInfo[field.fieldID + '_desc'] = field.getFieldInfo(); });
    this.comboFields.forEach(field => { this.additionalInfo[field.fieldID + '_desc'] = field.getFieldInfo(); });
    // this.fileUploadFields.forEach(field => {this.additionalInfo[field.fieldID + '_desc'] = field.getFieldInfo();});
    return this.additionalInfo;
  }
  getFieldValue() {
    return this.value;
  }
  setValue(inputValue, inputDesc = undefined) {
    this.setBasicFieldsValue(inputValue, inputDesc);
    this.value = new ChartModel();
    this.value.setValue(inputValue);
    this.setDependencies();
    this.passNewValue(this.value);
  }
  ngOnInit() {
    // this.changeSearchMode(this.searchMode);

    if (this.formCode == undefined) { this.formCode = 'Chart'; }
    if (this.formOnLoadError) { return; }
    setTimeout(() => {
      this.skeletonContentLoaded = true;
    }, 1000);
    var styleElement = document.createElement('style');
    styleElement.type = 'text/css';
    styleElement.innerHTML = customCss;
    styleElement.id = 'Chart_customCss';
    document.getElementsByTagName('head')[0].appendChild(styleElement);
  }
  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
    var styleElement = document.getElementById('Chart_customCss');
    styleElement.parentNode.removeChild(styleElement);
  }
  ngAfterViewInit() {
    setTimeout(() => {
      // this.subsBFldsValueUpdates();
      this.onFormLoad();
      this.checkForHTabOverFlow();
      // this.changeSearchMode(this.searchMode);

    });
  }
//   changeSearchMode(type: string) {
//     this.searchMode = type;
//     this.selectedOption.emit(this.searchMode);
// }

  clearError() {
    super.clearBasicFieldsError();
    super.clearHTabErrors();
    super.clearVTabErrors();
    this.errors = 0;
    this.errorMessage = [];
  }
  onReset() {
    super.resetBasicFields();
    this.clearHTabErrors();
    this.clearVTabErrors();
    this.errors = 0;
    this.errorMessage = [];
    this.additionalInfo = undefined;
    this.dependencyMap.clear();
    this.value = new ChartModel();
    this.passNewValue(this.value);
    this.setReadOnly(false);
    this.onFormLoad();
  }
  async cmbChart_change(event) {
    // let inputMap = new Map();
    this.chartSelected.emit({});
  }
  fieldDependencies = {
  }
  protected drawChart() {
    this.dataTable = anychart.data.table();
    this.mapping = this.dataTable.mapAs({
      'value': 1,
      'volume': 1,
      'open': 1,
      'high': 2,
      'low': 3,
      'close': 4
    });
    this.chart = anychart.stock();
    this.chart.credits().enabled(false);
    this.chart.plot(0).ohlc(this.mapping);
    this.table = anychart.data.table();
    this.table.addData(this.dataSource);

    // mapping the data
    this.mapping = this.table.mapAs();
    this.mapping.addField('open', 1, 'first');
    this.mapping.addField('high', 2, 'max');
    this.mapping.addField('low', 3, 'min');
    this.mapping.addField('close', 4, 'last');
    this.mapping.addField('value', 4, 'last');

    // defining the chart type
    this.chart = anychart.stock();
    this.chart.credits().enabled(false);
    // set the series type
    this.chart.plot(0).ohlc(this.mapping).name('ACME Corp.');

    // setting the chart title
    this.chart.title('MTAS CHART');

    // display the chart
    this.chart.container('container');
    this.chart.draw();
    console.log("this.hcar", this.chart)
  }



}